module.exports = __webpack_public_path__ + "img/check_on.bb9f14b7.svg";